import React from "react";
import { useSpring, animated } from "react-spring";
import styled from "styled-components";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CardWrapper = styled(animated.div)`
  perspective: 1000px;
  margin: 20px;
`;

const CardContent = styled.div`
  background: ${(props) => props.bg};
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform-style: preserve-3d;
  transition: transform 0.5s;
  &:hover {
    transform: rotateY(10deg) rotateX(10deg);
  }
`;

const CardButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: ${(props) => props.color};
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
`;

const Card2 = ({ bg, title, body, btn_text, btn_link, btn }) => {
  const { t } = useTranslation();
  const [props, set] = useSpring(() => ({
    transform: "rotateY(0deg) rotateX(0deg)",
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  let history = useHistory();

  const showDialog = () => {
    Swal.fire({
      title: t("declaration"),
      text: t("declaration_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("yes"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        history.push(btn_link);
      }
    });
  };

  return (
    <CardWrapper
      onMouseMove={({ clientX: x, clientY: y }) =>
        set({
          transform: `rotateY(${(x - window.innerWidth / 2) / 25}deg) rotateX(${
            -(y - window.innerHeight / 2) / 25
          }deg)`,
        })
      }
      onMouseLeave={() =>
        set({
          transform: "rotateY(0deg) rotateX(0deg)",
        })
      }
      style={props}
    >
      <CardContent bg={bg}>
        <h3>{title}</h3>
        <p>{body}</p>
        <CardButton color={btn} onClick={showDialog}>
          {btn_text}
        </CardButton>
      </CardContent>
    </CardWrapper>
  );
};

export default Card2;
